<!-- 海宁：增加质押银行行号展示（选择外部银行带出） -->
<template>
  <div class="pledgeTable">
    <vxe-toolbar size="mini" v-if="fundPaymentBillFlag == '1' ? false : isEdit && canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('cooperation.buttons.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('cooperation.buttons.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="pledgeTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // import API from '@/api/capitalCenter/moneyDraw';
  import { dateFormat } from '@/filters/index';

  export default {
    name: 'pledgeTable',
    components: {
      // SearchTable,
      // InputNumber,
    },
    props: ['isEdit', 'sysConfigFlag', 'companyList', 'canEdit', 'fundPaymentBillFlag'],
    data() {
      return {
        tableData: [],
        addRowObj: {
          id: null,
          pledgeCompanyCode: null,
          pledgeLineNo: null,
          pledgeBankNo: null,
          pledgeBankName: null,
          pledgeDate: null,
          redemptionDate: null,
          pledgeOperatorNo: null,
          pledgeOperatorName: null,
          pledgeOperateDate: null,
          pledgeBankAccount: null,
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      contractInfo() {
        return {
          contractStatus: 'ZT03',
          contractCategory: 'sales',
          companyCode: this.baseInfo.companyCode,
          departmentCode: this.baseInfo.departmentCode,
        };
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            // 公司代码
            field: 'pledgeCompanyCode',
            title: this.$t('billDetail.pledgeForm.pledgeCompanyCode'),
            width: 150,
            editRender: {
              name: 'ElSelect',
              options: this.companyList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            // 行项目
            field: 'pledgeLineNo',
            title: this.$t('billDetail.pledgeForm.pledgeLineNo'),
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            // 质押银行
            field: 'pledgeBankName',
            title: this.$t('billDetail.pledgeForm.pledgeBankNo'),
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.pledgeBankName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bankAccountBranchName"
                    isMultiple={true}
                    currentValue={row['pledgeBankName']}
                    checkRowKeys={[row['pledgeBankNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'pledgeBankName')}
                  ></search-table>,
                ];
              },
            },
          },
          {
            // 质押银行账号
            field: 'pledgeBankAccount',
            width: 150,
            title: this.$t('billDetail.pledgeForm.pledgeBankAccount'),
          },
          {
            // 质押日期
            field: 'pledgeDate',
            title: this.$t('billDetail.pledgeForm.pledgeDate'),
            width: 150,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 赎回日期
            field: 'redemptionDate',
            title: this.$t('billDetail.pledgeForm.redemptionDate'),
            width: 150,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            // 操作人
            field: 'pledgeOperatorName',
            title: this.$t('billDetail.pledgeForm.pledgeOperatorName'),
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            // 操作日期
            field: 'pledgeOperateDate',
            title: this.$t('billDetail.pledgeForm.pledgeOperateDate'),
            width: 150,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
        ];
      },
      rules() {
        //赎回日期大于质押日期
        const redemptionDateValid = (rule, cellValue, callback, { row }) => {
          if (row['pledgeDate'] && cellValue && cellValue <= row['pledgeDate']) {
            callback(new Error('赎回日期必须大于质押日期!'));
          } else {
            callback();
          }
        };
        //赎回日期大于质押日期
        const pledgeDateValid = (rule, cellValue, callback, { row }) => {
          if (row['redemptionDate'] && cellValue && cellValue >= row['redemptionDate']) {
            callback(new Error('质押日期必须小于赎回日期!'));
          } else {
            callback();
          }
        };
        return {
          pledgeDate: [
            {
              required: true,
              message: this.$t('billDetail.pledgeColumnPlaceholder.pledgeDatePlaceholder'),
            },
            { validator: pledgeDateValid },
          ],
          redemptionDate: [{ validator: redemptionDateValid }],
        };
      },
    },
    mounted() {
      if (this.$route.name.indexOf('Add') != '-1') {
        this.addRowObj.pledgeOperatorNo = this.userInfo.userCode;
        this.addRowObj.pledgeOperatorName = this.userInfo.userName;
        this.addRowObj.pledgeOperateDate = dateFormat(new Date());
      }
    },
    methods: {
      chooseTable(val, row, prop) {
        if (prop == 'pledgeBankName') {
          this.pledgeBankChange(val, row);
        }
      },
      pledgeBankChange(val, row) {
        if (val && val.length > 0) {
          row.pledgeBankName = val[0].branchName;
          row.pledgeBankNo = val[0].branchCode;
          row.pledgeBankAccount = val[0].bankAccountNum;
        } else {
          row.pledgeBankName = null;
          row.pledgeBankNo = null;
          row.pledgeBankAccount = null;
        }
      },
      // 载具表格新增一行
      insertEvent(row) {
        this.$refs.pledgeTable.validate().then(() => {
          let record = { ...this.addRowObj };
          this.$refs.pledgeTable.insertAt(record, row).then(({ row }) => {
            this.$refs.pledgeTable.setActiveRow(row);
          });
        });
      },
      handleDelete() {
        const selectedList = this.$refs.pledgeTable.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.pledgeTable.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      activeRowMethod(fundPaymentBillFlag) {
        return fundPaymentBillFlag == '1' ? false : this.isEdit && this.canEdit;
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.pledgeTable.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.pledgeTable.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
